import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { TabsContent } from '@/components/ui/tabs';

const AdminBookingsTab = ({ bookings, getStatusColor, expandedBookingId, setExpandedBookingId }) => {
  return (
    <TabsContent value="bookings">
      {bookings.length === 0 ? (
        <div className="glass-card p-12 text-center">
          <p className="text-gray-400 text-lg">No bookings yet.</p>
        </div>
      ) : (
        <div className="space-y-4" data-testid="bookings-list">
          {bookings.map((booking) => (
            <div key={booking.id} className="glass-card p-6" data-testid={`booking-card-${booking.id}`}>
              <div className="space-y-4">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                  <button
                    type="button"
                    onClick={() => setExpandedBookingId((prev) => (prev === booking.id ? null : booking.id))}
                    className="flex-1 text-left"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      <div>
                        <p className="text-sm text-gray-400 mb-1">Customer</p>
                        <p className="font-semibold">{booking.user_name}</p>
                        <p className="text-sm text-gray-400">{booking.user_email}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-400 mb-1">Designer</p>
                        <p className="font-semibold">{booking.designer_name}</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-400 mb-1">Date & Time</p>
                        <p className="font-semibold">{booking.booking_date}</p>
                        <p className="text-sm text-gray-400">{booking.time_slot}</p>
                      </div>
                      <div className="flex flex-col justify-between">
                        <div>
                          <p className="text-sm text-gray-400 mb-1">Amount</p>
                          <p className="font-bold text-[#d4a574] text-xl">{Number(booking.amount || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' })}</p>
                        </div>
                        <span className={`px-3 py-1 rounded-full text-sm font-medium w-fit ${getStatusColor(booking.status)}`}>
                          {booking.status}
                        </span>
                      </div>
                    </div>
                  </button>
                  <button
                    type="button"
                    onClick={() => setExpandedBookingId((prev) => (prev === booking.id ? null : booking.id))}
                    className="px-4 py-2 rounded-lg bg-[#d4a574]/10 text-[#d4a574] hover:bg-[#d4a574]/20 transition-colors flex items-center justify-center gap-2 shrink-0"
                  >
                    {expandedBookingId === booking.id ? (
                      <>
                        <ChevronUp className="w-4 h-4" />
                        Collapse
                      </>
                    ) : (
                      <>
                        <ChevronDown className="w-4 h-4" />
                        Expand
                      </>
                    )}
                  </button>
                </div>

                {expandedBookingId === booking.id && (
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 pt-4 border-t border-[#d4a574]/10">
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Booking ID</p>
                      <p className="font-semibold break-all">{booking.id}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Phone</p>
                      <p className="font-semibold">{booking.phone || 'Not provided'}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Payment Ref</p>
                      <p className="font-semibold break-all">{booking.payment_session_id || 'Not created yet'}</p>
                    </div>
                    <div className="md:col-span-2 xl:col-span-3">
                      <p className="text-sm text-gray-400 mb-1">Address</p>
                      <p className="text-gray-300 whitespace-pre-line">{booking.address || 'Not provided'}</p>
                    </div>
                    <div className="md:col-span-2 xl:col-span-3">
                      <p className="text-sm text-gray-400 mb-1">Notes</p>
                      <p className="text-gray-300 whitespace-pre-line">{booking.notes || 'No notes provided.'}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </TabsContent>
  );
};

export default AdminBookingsTab;
